import React from "react";
import { Route, withRouter } from "react-router-dom";
import { object } from "prop-types";
import ReduxToastr from "react-redux-toastr";

import "../utils/Rollbar";

import Login from "./Login";
import Campaigns from "./Campaigns";
import PrivateRoute from "../utils/PrivateRoute";

const App = ({ location }) => {
  return (
    <div>
      <Route exact path="/" component={Login} />
      <PrivateRoute path="/campaigns" location={location} component={Campaigns} />
      <ReduxToastr />
    </div>
  );
};

App.propTypes = {
  location: object
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/containers/App.js